var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRateStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2862 12.3568L21.6612 17.2105L23.3749 24.4693C23.4695 24.8633 23.4451 25.2766 23.305 25.6568C23.1648 26.037 22.9151 26.3671 22.5873 26.6055C22.2596 26.8438 21.8686 26.9797 21.4637 26.996C21.0588 27.0122 20.6582 26.9081 20.3124 26.6968L13.9999 22.8118L7.68367 26.6968C7.33796 26.9069 6.9378 27.01 6.5336 26.9932C6.12939 26.9763 5.7392 26.8403 5.41217 26.6021C5.08514 26.3639 4.83589 26.0343 4.6958 25.6548C4.55571 25.2753 4.53105 24.8628 4.62492 24.4693L6.34492 17.2105L0.719922 12.3568C0.414045 12.0924 0.192828 11.7438 0.0839002 11.3545C-0.0250279 10.9651 -0.0168401 10.5523 0.107441 10.1676C0.231722 9.78291 0.466588 9.44333 0.782708 9.19131C1.09883 8.93928 1.48219 8.78598 1.88492 8.75053L9.25992 8.15553L12.1049 1.27053C12.2589 0.895301 12.521 0.57434 12.8579 0.348452C13.1948 0.122564 13.5912 0.00195312 13.9968 0.00195312C14.4024 0.00195312 14.7988 0.122564 15.1357 0.348452C15.4726 0.57434 15.7347 0.895301 15.8887 1.27053L18.7324 8.15553L26.1074 8.75053C26.511 8.78466 26.8954 8.93711 27.2127 9.18879C27.53 9.44046 27.7659 9.78017 27.891 10.1653C28.016 10.5505 28.0246 10.964 27.9157 11.3541C27.8068 11.7441 27.5852 12.0934 27.2787 12.358L27.2862 12.3568Z",
    fill: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateStar);
export default __webpack_public_path__ + "static/media/rate-star.d15c464b549109426861e0cbfdde5179.svg";
export { ForwardRef as ReactComponent };